/**
 * Inject the proper api base url depending on the current domain
 *
 * @param config
 *
 * @returns {*}
 */

const defaultUrl = 'http://api.staging.frilansfinans.se/';

import * as variables from './variables';

export function replaceBackendUri (config) {
  if (config.url.substring(0, 10) === 'backend://') {
    let url = variables.apiUrl || defaultUrl;
    config.url = url + config.url.substring(10);
  }
  return config;
}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/replace-backend-uri.js
 **/